import { Link, useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { useEffect, useRef, useState } from "react";
import EditIcon from "../../../components/Icons/EditIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { toast } from "react-toastify";
import CommonTable from "../../../components/comman/CommonTable";
import FilterComponent from "../../../components/comman/FilterComponent";
import MainHeading from "../../../components/comman/MainHeading";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { useDispatch, useSelector } from "react-redux";
import { updateFiltersStates } from "../../../store/actions/UserActions";

export default function SitesOandM() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const userDetails = useSelector((state) => state.root.userDetails);
  const timeoutId = useRef(null);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    SiteData: [],
    filterData: "",
    searchQuery: "",
    type: "O%26M",
    status: "",
  });

  useEffect(() => {
    GetSiteList();
  }, [
    pageStates?.searchQuery,
    pageStates?.currentPage,
    pageStates.pageSize,
    filterDetails?.orderBy,
    pageStates?.status,
  ]);

  const isUserAccess = userDetails?.type === 2;

  const GetSiteList = () => {
    let options = {
      method: "GET",
    };
    let API =
      userDetails?.type === 2 || userDetails?.designation?.name === "Director"
        ? apiUrl.get_site
        : apiUrl.get_user_site;
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      SiteData: {},
    }));
    callApi(
      API +
      "?" +
      MainFilterHandler({ ...pageStates, orderBy: filterDetails?.orderBy, status: pageStates?.status }),
      options,
    ).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.site?.map((item) => ({
          ...item,
          companyName: item?.Company?.name || item?.site?.Company?.name,
          customerName: item?.customer?.name || item?.site?.customer?.name,

          name:
            userDetails?.type === 2 ||
              userDetails?.designation?.name === "Director"
              ? item?.name
              : item?.site?.name,
          code:
            userDetails?.type === 2 ||
              userDetails?.designation?.name === "Director"
              ? item?.code
              : item?.site?.code,

          address:
            userDetails?.type === 2 ||
              userDetails?.designation?.name === "Director"
              ? item?.address
              : item?.site?.address,
          range:
            userDetails?.type === 2 ||
              userDetails?.designation?.name === "Director"
              ? item?.range
              : item?.site?.range,
          toggleStatus:
            userDetails?.type === 2 ||
              userDetails?.designation?.name === "Director"
              ? item?.status
              : item?.site?.status,
          siteStatus:
            userDetails?.type === 2 ||
              userDetails?.designation?.name === "Director"
              ? item?.status
              : item?.site?.status,
          isUserAccess: 1,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          SiteData: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
          siteStatus: response?.data?.status,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const HandleView = (data) => {
    if (
      userDetails?.type === 2 ||
      userDetails?.designation?.name === "Director"
    ) {
      navigate(`${RoutesLink?.site_detail}/${data?.id}`);
    } else {
      navigate(`${RoutesLink?.site_detail}/${data?.site?.id}`);
    }
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.add_site, { state: { data: data } });
  };

  const handleStatusToggle = (data, status) => {
    let formData = new FormData();
    formData.append("status", status ? 0 : 1);

    const options = {
      method: "POST",
      form_data: formData,
    };
    let API =
      apiUrl?.update_site +
      `?siteId=${userDetails?.type === 2 || userDetails?.designation?.name === "Director" ? data?.id : data?.site?.id}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
        GetSiteList(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const status = isUserAccess
    ? { value: "toggleStatus", label: "Status" }
    : { value: "siteStatus", label: "Status" };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "name", label: "Site" },
    { value: "code", label: "Site Code" },
    { value: "companyName", label: "Company" },
    { value: "customerName", label: "Customer" },
    { value: "address", label: "Address" },
    { value: "range", label: "Range" },
    status,
  ];

  const ActionData = [
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
    ...(isUserAccess
      ? [
          {
            label: "Edit",
            className: "btn btn-link",
            icon: <EditIcon />,
            title: "edit",
            isShow: true,
            isSiteEditable: 1,
            clickHandler: HandleUpdate,
          },
        ]
      : []),
  ];

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      dispatch(updateFiltersStates({ currentPage: 1 }));
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 300);
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      }),
    );
  };


  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  const orderByStatus = (e) => {
    setPageStates((prev) => ({
      ...prev,
      status: e.target.value,
      currentPage: 1,
    }));
  };

  const orderByStatusList = [
    { value: "", name: "All" },
    { value: 1, name: "Active" },
    { value: 0, name: "Inactive" },
  ];

  return (
    <>
      <>
        <MainHeading
          title={"O&M Sites"}
          buttonText={isUserAccess && "Add New Site"}
          buttonIcon={isUserAccess && <PlusIcon />}
          buttonLink={isUserAccess && RoutesLink?.add_site}
          state={{ type: "O&M" }}
        />
        <div className="card mb-4">
          <div className="card-body">
            <FilterComponent
              handleSearch={handleSearchChange}
              searchPlaceHolder={"Search By Site Name"}
              orderByHandler={orderByHandler}
              orderByList={orderByList}
              orderByStatus={userDetails?.type === 2 || userDetails?.designation?.name === "Director" ? orderByStatus : null}
              orderByStatusList={orderByStatusList}
              pageStates={pageStates}
            />
            <CommonTable
              TableHeading={TableHeading}
              TableData={pageStates?.SiteData}
              ActionData={ActionData}
              currentPage={pageStates?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates?.totalPages}
              count={pageStates?.count}
              handleStatusToggle={handleStatusToggle}
              handleChangePageSize={handleChangePageSize}
              pageSize={pageStates.pageSize}
            />
          </div>
        </div>
      </>
    </>
  );
}
